import React from 'react';
import { event } from '@uhg-abyss/web/tools/event';
import { SideTab } from '@sde/widgets-core/src/common/SideTab';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { IconFeedback } from '../IconFeedback/IconFeedback';

export const FeedbackTab = () => {
  const handleClick = () => {
    event('FEEDBACK');
    event('CLICK_ACTION', {
      interactionName: 'Feedback Button Click',
      interactionValue: 'Feedback Button Clicked',
    });
    console.log('Feedback Clicked');
  };
  return (
    <If condition={getFeature('QUALTRICS_SURVEY')}>
      <SideTab
        onClick={() => handleClick()}
        variant="outline"
        before={<IconFeedback size={16} color="$primary1" />}
        offset={530}
      >
        Feedback
      </SideTab>
    </If>
  );
};
